import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/yxb1.jpg';
import _imports_1 from '@/assets/gslogo.png';
import _imports_2 from '@/assets/xin1.png';
import _imports_3 from '@/assets/as.png';
import _imports_4 from '@/assets/ewm.png';
import _imports_5 from '@/assets/sph.jpg';
import _imports_6 from '../../assets/logo.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7b247b90"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "margin": "auto",
    "display": "flex",
    "flex-direction": "row"
  }
};
var _hoisted_2 = {
  class: "center"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "100%",
      "height": "100%"
    }
  })], -1);
});

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"fromstyle-wz\" data-v-7b247b90><span class=\"wz-zun\" style=\"text-align:center;\" data-v-7b247b90>智能焊接工艺精准赋能计划</span><p class=\"wz-nei\" style=\"margin-top:15px;margin-bottom:15px;\" data-v-7b247b90>尊敬的行业伙伴：</p><p class=\"wz-nei\" data-v-7b247b90>在精密焊接领域，0.01mm的工艺偏差可能意味着百万级返工损失。当前行业普遍存在的BGA虚焊、微焊点偏移及空洞缺陷等&quot;黑箱症结&quot;，正在持续侵蚀您的良率与利润空间。</p><p class=\"wz-nei\" data-v-7b247b90>为加速破解这一困局，我们推出「工艺数智化Demo服务」，您的专业反馈将直接影响技术落地方向。提交Demo试用申请，即可：</p><p class=\"wz-nei\" data-v-7b247b90>1⃣ 抢占产线级预部署资格，首期仅开放30个深度诊断名额；</p><p class=\"wz-nei\" data-v-7b247b90>2⃣ 获得焊接工艺数字画像报告，含缺陷诊断及整改优先级方案；</p><p class=\"wz-nei\" data-v-7b247b90>每份精准数据，都是解锁产线潜力的密钥，完整填写后，技术顾问将在3个工作日内致电反馈，期待与您携手重构焊接质量基线！</p><p class=\"wz-nei\" style=\"margin-top:15px;\" data-v-7b247b90>注：高信息密度的申请将优先获得产线实测档期及研发资源倾斜，建议由工艺/质量主管联合填写。</p></div>", 1);

var _hoisted_5 = {
  class: "zheng"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "请先填写您的基本信息")])], -1);
});

var _hoisted_7 = {
  class: "bottom",
  style: {
    "padding-right": "15px"
  }
};
var _hoisted_8 = {
  class: "zheng"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "1.您目前使用的回流炉是什么品牌？（多选）")])], -1);
});

var _hoisted_10 = {
  class: "bottom"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_12 = ["disabled"];
var _hoisted_13 = {
  class: "zheng"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "2.您目前使用的焊接工艺是什么？（多选）")])], -1);
});

var _hoisted_15 = {
  class: "bottom"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_17 = ["disabled"];
var _hoisted_18 = {
  class: "zheng"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "3.您所在的厂区回流炉设备数量有多少台？（单选）")])], -1);
});

var _hoisted_20 = {
  class: "bottom"
};

var _hoisted_21 = /*#__PURE__*/_createTextVNode("01-10台");

var _hoisted_22 = /*#__PURE__*/_createTextVNode("10-20台");

var _hoisted_23 = /*#__PURE__*/_createTextVNode("20-40台");

var _hoisted_24 = /*#__PURE__*/_createTextVNode("40-60台");

var _hoisted_25 = /*#__PURE__*/_createTextVNode("60台以上");

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_27 = ["disabled"];
var _hoisted_28 = {
  class: "zheng"
};

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "4.您的回流炉设备使用了多久？（单选）")])], -1);
});

var _hoisted_30 = {
  class: "bottom"
};

var _hoisted_31 = /*#__PURE__*/_createTextVNode("0-1年");

var _hoisted_32 = /*#__PURE__*/_createTextVNode("1-3年");

var _hoisted_33 = /*#__PURE__*/_createTextVNode("3-5年");

var _hoisted_34 = /*#__PURE__*/_createTextVNode("5年以上");

var _hoisted_35 = {
  class: "zheng"
};

var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "5.您使用的回流炉主要应用在哪些领域？（多选）")])], -1);
});

var _hoisted_37 = {
  class: "bottom"
};

var _hoisted_38 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_39 = ["disabled"];
var _hoisted_40 = {
  class: "zheng"
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "6.您认为哪些参数对于回流炉的性能最为关键？（多选）")])], -1);
});

var _hoisted_42 = {
  class: "bottom"
};

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_44 = ["disabled"];
var _hoisted_45 = {
  class: "zheng"
};

var _hoisted_46 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "7.您在使用回流炉过程中遇到过哪些工艺问题？（多选）")])], -1);
});

var _hoisted_47 = {
  class: "bottom"
};

var _hoisted_48 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_49 = ["disabled"];
var _hoisted_50 = {
  class: "zheng"
};

var _hoisted_51 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "8.您在使用回流炉过程中遇到过哪些困难？（多选）")])], -1);
});

var _hoisted_52 = {
  class: "bottom"
};

var _hoisted_53 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_54 = ["disabled"];
var _hoisted_55 = {
  class: "zheng"
};

var _hoisted_56 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "9.贵司需要以下哪些技能优化？（多选）")])], -1);
});

var _hoisted_57 = {
  class: "bottom"
};

var _hoisted_58 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_59 = ["disabled"];
var _hoisted_60 = {
  class: "zheng"
};

var _hoisted_61 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "10.您对哪些服务感兴趣？（多选）")])], -1);
});

var _hoisted_62 = {
  class: "bottom"
};
var _hoisted_63 = {
  class: "zheng"
};

var _hoisted_64 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "11.您期望Demo的产品是？（多选）")])], -1);
});

var _hoisted_65 = {
  class: "bottom1"
};

var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_67 = ["disabled"];
var _hoisted_68 = {
  class: "zheng"
};

var _hoisted_69 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "12.若试用满意，您是否愿意？（多选）")])], -1);
});

var _hoisted_70 = {
  class: "bottom"
};
var _hoisted_71 = {
  class: "zheng"
};

var _hoisted_72 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "13.若试用满意，您是否愿意购买？（单选）")])], -1);
});

var _hoisted_73 = {
  class: "bottom"
};

var _hoisted_74 = /*#__PURE__*/_createTextVNode("是");

var _hoisted_75 = /*#__PURE__*/_createTextVNode("否");

var _hoisted_76 = {
  class: "zheng"
};

var _hoisted_77 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "14.如果Demo验证有效，贵司可接受的设备投资范围是？（单选）")])], -1);
});

var _hoisted_78 = {
  class: "bottom"
};

var _hoisted_79 = /*#__PURE__*/_createTextVNode("＜￥50万");

var _hoisted_80 = /*#__PURE__*/_createTextVNode("￥50-200万");

var _hoisted_81 = /*#__PURE__*/_createTextVNode("￥200-500万");

var _hoisted_82 = /*#__PURE__*/_createTextVNode("＞￥500万");

var _hoisted_83 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "请说明期望回本周期：", -1);
});

var _hoisted_84 = ["disabled"];

var _hoisted_85 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "fromstyle-wz"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "wz-nei",
    style: {
      "font-weight": "600"
    }
  }, " 感谢您抽出宝贵的时间参与此次问卷调研，您的热情参与，将共同助力回流焊焊接技术的进步，为电子制造行业的可持续发展贡献您的智慧与经验。 ")], -1);
});

var _hoisted_86 = {
  class: "bottoms"
};
var _hoisted_87 = {
  class: "bottom-btn"
};
var _hoisted_88 = {
  key: 0,
  class: "dibu"
};

var _hoisted_89 = /*#__PURE__*/_createStaticVNode("<div class=\"dibu-kuan\" data-v-7b247b90><div data-v-7b247b90>本次问卷调研由以下单位共同参与及发起：</div><div class=\"dibu-center\" data-v-7b247b90><div class=\"center-wen\" data-v-7b247b90><div style=\"margin:auto;\" data-v-7b247b90> 跬步磐石（薛广辉工作室） </div></div><div class=\"center-tu\" style=\"margin:0px 20px;\" data-v-7b247b90><img src=\"" + _imports_1 + "\" alt=\"\" data-v-7b247b90></div><div style=\"width:26%;\" data-v-7b247b90><img style=\"width:60%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-7b247b90></div></div><div style=\"display:flex;\" data-v-7b247b90><div style=\"margin:auto;\" data-v-7b247b90>参与问卷调研，共创未来！感谢您的支持与合作！</div></div></div>", 1);

var _hoisted_90 = [_hoisted_89];
var _hoisted_91 = {
  key: 1,
  class: "dibu"
};

var _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"dibu-kuan\" data-v-7b247b90><div data-v-7b247b90>本次问卷调研由以下单位共同参与及发起：</div><div class=\"dibu-center\" data-v-7b247b90><div class=\"center-wen\" style=\"margin-top:10px;\" data-v-7b247b90><div style=\"margin:auto;\" data-v-7b247b90> 跬步磐石（薛广辉工作室） </div></div><div class=\"center-tu\" style=\"margin:0px 10px;\" data-v-7b247b90><img src=\"" + _imports_1 + "\" alt=\"\" data-v-7b247b90></div><div style=\"margin:5px 0;width:30%;\" data-v-7b247b90><img style=\"width:110%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-7b247b90></div></div><div style=\"display:flex;\" data-v-7b247b90><div style=\"margin:auto;\" data-v-7b247b90>参与问卷调研，共创未来！感谢您的支持与合作！</div></div></div>", 1);

var _hoisted_93 = [_hoisted_92];
var _hoisted_94 = {
  key: 2,
  class: "dibu"
};

var _hoisted_95 = /*#__PURE__*/_createStaticVNode("<div class=\"dibu-kuan\" data-v-7b247b90><div data-v-7b247b90>本次问卷调研由以下单位共同参与及发起：</div><div class=\"dibu-center\" data-v-7b247b90><div class=\"center-tu\" data-v-7b247b90><img src=\"" + _imports_1 + "\" alt=\"\" data-v-7b247b90></div><div class=\"center-tu1\" data-v-7b247b90><img src=\"" + _imports_3 + "\" alt=\"\" data-v-7b247b90></div></div><div class=\"dibu-center\" data-v-7b247b90><div style=\"margin:auto 0;\" data-v-7b247b90> 跬步磐石（薛广辉工作室） </div><div style=\"width:150px;\" data-v-7b247b90><img style=\"width:76%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-7b247b90></div></div><div style=\"display:flex;\" data-v-7b247b90><div style=\"margin:auto;\" data-v-7b247b90>参与问卷调研，共创未来！感谢您的支持与合作！</div></div></div>", 1);

var _hoisted_96 = [_hoisted_95];

var _hoisted_97 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })], -1);
});

var _hoisted_98 = [_hoisted_97];
var _hoisted_99 = {
  class: "model"
};

var _hoisted_100 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "zhe"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "zhe-tu"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    style: {
      "width": "175px",
      "height": "175px"
    }
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "zhe-wen"
  }, " 关注视频号，了解更多丰富内容！ ")], -1);
});

var _hoisted_101 = {
  key: 0,
  class: "scan-login"
};
var _hoisted_102 = {
  class: "centont"
};

var _hoisted_103 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "logo"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "公司logo"
  })], -1);
});

var _hoisted_104 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "扫码登录", -1);
});

var _hoisted_105 = {
  class: "qr-code-container"
};
var _hoisted_106 = {
  key: 0,
  class: "qr-code-wrapper"
};
var _hoisted_107 = ["src"];
var _hoisted_108 = {
  key: 0,
  class: "overlay"
};

var _hoisted_109 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "二维码已失效", -1);
});

var _hoisted_110 = {
  key: 1
};

var _hoisted_111 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "正在加载二维码...", -1);
});

var _hoisted_112 = [_hoisted_111];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "main",
    style: _normalizeStyle('padding-top:' + $data.mainpadding + 'px;')
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass({
      'centerShow': $data.bwidth
    })
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: _normalizeClass($data.phoneShow ? 'fromstyle1' : 'fromstyle')
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
    modelValue: $data.bus.company,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.bus.company = $event;
    }),
    placeholder: "请输入您的公司名称"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.contact,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.bus.contact = $event;
    }),
    placeholder: "联系人",
    style: {
      "margin": "10px 0px"
    }
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.phone,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.bus.phone = $event;
    }),
    placeholder: "联系电话"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.position,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.bus.position = $event;
    }),
    placeholder: "请输入您的职务",
    style: {
      "margin": "10px 0px"
    }
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.email,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.bus.email = $event;
    }),
    placeholder: "请输入您的电子邮箱"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice1,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.dx.multiplechoice1 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData1, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item.name,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[6] || (_cache[6] = function ($event) {
          return $options.xz1($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_11, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return $data.tk.suggestions1 = $event;
            }),
            disabled: $options.tk1()
          }, null, 8, _hoisted_12), [[_vModelText, $data.tk.suggestions1]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice8,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return $data.dx.multiplechoice8 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData2, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[9] || (_cache[9] = function ($event) {
          return $options.xz8($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_16, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return $data.tk.suggestions8 = $event;
            }),
            disabled: $options.tk8()
          }, null, 8, _hoisted_17), [[_vModelText, $data.tk.suggestions8]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.singlechoice3,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.bus.singlechoice3 = $event;
    }),
    class: "ml-4",
    onChange: _cache[13] || (_cache[13] = function ($event) {
      return $options.xz2($event);
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "01-10台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_21];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "10-20台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_22];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "20-40台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_23];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "40-60台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_24];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "60台以上"
      }, {
        default: _withCtx(function () {
          return [_hoisted_25];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "其它"
      }, {
        default: _withCtx(function () {
          return [_hoisted_26, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
              return $data.tk.suggestions2 = $event;
            }),
            disabled: $options.tk2()
          }, null, 8, _hoisted_27), [[_vModelText, $data.tk.suggestions2]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.singlechoice4,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.bus.singlechoice4 = $event;
    }),
    class: "ml-4",
    size: "small"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "0-1年"
      }, {
        default: _withCtx(function () {
          return [_hoisted_31];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "1-3年"
      }, {
        default: _withCtx(function () {
          return [_hoisted_32];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "3-5年"
      }, {
        default: _withCtx(function () {
          return [_hoisted_33];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "5年以上"
      }, {
        default: _withCtx(function () {
          return [_hoisted_34];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice2,
    "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
      return $data.dx.multiplechoice2 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData4, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[16] || (_cache[16] = function ($event) {
          return $options.xz3($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_38, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
              return $data.tk.suggestions3 = $event;
            }),
            disabled: $options.tk3()
          }, null, 8, _hoisted_39), [[_vModelText, $data.tk.suggestions3]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice3,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
      return $data.dx.multiplechoice3 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData5, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[19] || (_cache[19] = function ($event) {
          return $options.xz4($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_43, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
              return $data.tk.suggestions4 = $event;
            }),
            disabled: $options.tk4()
          }, null, 8, _hoisted_44), [[_vModelText, $data.tk.suggestions4]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice4,
    "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
      return $data.dx.multiplechoice4 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData6, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[22] || (_cache[22] = function ($event) {
          return $options.xz5($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_48, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
              return $data.tk.suggestions5 = $event;
            }),
            disabled: $options.tk5()
          }, null, 8, _hoisted_49), [[_vModelText, $data.tk.suggestions5]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice5,
    "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
      return $data.dx.multiplechoice5 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData7, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[25] || (_cache[25] = function ($event) {
          return $options.xz6($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_53, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
              return $data.tk.suggestions6 = $event;
            }),
            disabled: $options.tk6()
          }, null, 8, _hoisted_54), [[_vModelText, $data.tk.suggestions6]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice6,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
      return $data.dx.multiplechoice6 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData8, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[28] || (_cache[28] = function ($event) {
          return $options.xz7($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_58, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
              return $data.tk.suggestions7 = $event;
            }),
            disabled: $options.tk7()
          }, null, 8, _hoisted_59), [[_vModelText, $data.tk.suggestions7]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_60, [_hoisted_61, _createElementVNode("div", _hoisted_62, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice7,
    "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) {
      return $data.dx.multiplechoice7 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData9, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_63, [_hoisted_64, _createElementVNode("div", _hoisted_65, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice9,
    "onUpdate:modelValue": _cache[33] || (_cache[33] = function ($event) {
      return $data.dx.multiplechoice9 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData15, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[32] || (_cache[32] = function ($event) {
          return $options.xz9($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_66, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[31] || (_cache[31] = function ($event) {
              return $data.tk.suggestions9 = $event;
            }),
            disabled: $options.tk9()
          }, null, 8, _hoisted_67), [[_vModelText, $data.tk.suggestions9]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_68, [_hoisted_69, _createElementVNode("div", _hoisted_70, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice10,
    "onUpdate:modelValue": _cache[34] || (_cache[34] = function ($event) {
      return $data.dx.multiplechoice10 = $event;
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData14, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_71, [_hoisted_72, _createElementVNode("div", _hoisted_73, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.singlechoice1,
    "onUpdate:modelValue": _cache[35] || (_cache[35] = function ($event) {
      return $data.bus.singlechoice1 = $event;
    }),
    class: "ml-4",
    size: "small"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "是"
      }, {
        default: _withCtx(function () {
          return [_hoisted_74];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "否"
      }, {
        default: _withCtx(function () {
          return [_hoisted_75];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_76, [_hoisted_77, _createElementVNode("div", _hoisted_78, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.singlechoice2,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) {
      return $data.bus.singlechoice2 = $event;
    }),
    class: "ml-4",
    onChange: _cache[38] || (_cache[38] = function ($event) {
      return $options.xz10($event);
    }),
    size: "small"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "＜￥50万"
      }, {
        default: _withCtx(function () {
          return [_hoisted_79];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "￥50-200万"
      }, {
        default: _withCtx(function () {
          return [_hoisted_80];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "￥200-500万"
      }, {
        default: _withCtx(function () {
          return [_hoisted_81];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "＞￥500万"
      }, {
        default: _withCtx(function () {
          return [_hoisted_82];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "其它"
      }, {
        default: _withCtx(function () {
          return [_hoisted_83, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[36] || (_cache[36] = function ($event) {
              return $data.tk.suggestions10 = $event;
            }),
            disabled: $options.tk10()
          }, null, 8, _hoisted_84), [[_vModelText, $data.tk.suggestions10]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _hoisted_85], 2), _createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("div", {
    class: "bottom-tj",
    onClick: _cache[39] || (_cache[39] = function ($event) {
      return $options.busAdd(_ctx.ruleFormRef);
    })
  }, " 提交 ")])])]), $data.bwidth ? (_openBlock(), _createElementBlock("div", _hoisted_88, _hoisted_90)) : (_openBlock(), _createElementBlock("div", _hoisted_91, _hoisted_93)), false ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96)) : _createCommentVNode("", true)], 2), $data.phoneShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tu",
    onClick: _cache[40] || (_cache[40] = function () {
      return $options.tuShow && $options.tuShow.apply($options, arguments);
    })
  }, _hoisted_98)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_99, [_createVNode(_component_el_dialog, {
    modelValue: $data.imgStatus,
    "onUpdate:modelValue": _cache[41] || (_cache[41] = function ($event) {
      return $data.imgStatus = $event;
    }),
    width: "240px",
    draggable: true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(function () {
      return [_hoisted_100];
    }),
    _: 1
  }, 8, ["modelValue"])])], 4), $data.loginShow ? (_openBlock(), _createElementBlock("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_hoisted_103, _hoisted_104, _createElementVNode("div", _hoisted_105, [$data.qrCodeUrl ? (_openBlock(), _createElementBlock("div", _hoisted_106, [_createElementVNode("img", {
    src: $data.qrCodeUrl,
    alt: "二维码"
  }, null, 8, _hoisted_107), $data.isQrCodeExpired ? (_openBlock(), _createElementBlock("div", _hoisted_108, [_hoisted_109, _createElementVNode("button", {
    onClick: _cache[42] || (_cache[42] = function () {
      return $options.refreshQrCode && $options.refreshQrCode.apply($options, arguments);
    })
  }, "点击刷新")])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_110, _hoisted_112))])])])) : _createCommentVNode("", true)]);
}